import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import PropTypes from "prop-types";
import styled from "styled-components";

const FilterInput = styled.input`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  margin-bottom: 8px;

  &:focus {
    outline: none;
    border-color: #0066cc;
    box-shadow: 0 0 0 2px rgba(0, 102, 204, 0.1);
  }
`;

const DropdownMenuStyled = styled(Dropdown.Menu)`
  width: 100%;
  max-height: 300px;
  overflow-y: auto;
`;

const VoiceDropdown = ({ value, options, onChange, loading, disabled }) => {
  const [filter, setFilter] = useState("");
  const safeOptions = Array.isArray(options) ? options : [];
  
  const filteredOptions = safeOptions.filter((option) =>
    option.label.toLowerCase().includes(filter.toLowerCase())
  );

  return (
    <Dropdown disabled={disabled || loading}>
      <Dropdown.Toggle variant="dark" id="dropdown-voices">
        {safeOptions.find((option) => option.value === value)?.label || "Selecione a voz"}
      </Dropdown.Toggle>
      <DropdownMenuStyled>
        <div style={{ padding: "8px" }} onClick={(e) => e.stopPropagation()}>
          <FilterInput
            type="text"
            placeholder="Filtrar vozes..."
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            autoFocus
          />
        </div>
        <Dropdown.Item onClick={() => onChange(null)}>Selecione a voz</Dropdown.Item>
        {filteredOptions.map((option, index) => (
          <Dropdown.Item key={index} onClick={() => onChange(option.value)}>
            {option.label}
          </Dropdown.Item>
        ))}
        {filteredOptions.length === 0 && (
          <Dropdown.Item disabled>Nenhuma voz encontrada</Dropdown.Item>
        )}
      </DropdownMenuStyled>
    </Dropdown>
  );
};

VoiceDropdown.propTypes = {
  value: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
  onChange: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
};

VoiceDropdown.defaultProps = {
  value: null,
  loading: false,
  disabled: false,
};

export default VoiceDropdown;